<template>
	<ProgressSpinner v-if="!user"/>
	<Container class="pt-6" v-if="user">

    <div
        v-if="user.companies?.length === 0">
      <Alert>
        {{ $t('pages.admin.users.users.user.user_view.this_user_is_missing_some_required_information') }}

        <template #list>
          <li v-if="user.companies?.length === 0">
            {{ $t('pages.admin.users.users.user.user_view.this_user_is_not_associated_with_any_companies') }}
          </li>
        </template>
      </Alert>
    </div>

    <div class="bg-surface-0 dark:bg-surface-900 -mx-8 px-8 -mt-6 pt-6 -mb-4 pb-4">
			<PageHeading>{{ user.name ?? $route.params.user }}</PageHeading>
		</div>

		<div class="sticky top-0 bg-surface-0 dark:bg-surface-800 z-40 -mx-8 -px-8">
			<TabLayout :tabs="tabs" sticky/>
		</div>

		<router-view
				@on-save="$emit('on-save')"
				@refresh-user="refreshUser"
				:user="user"
		></router-view>
	</Container>
</template>

<script>
import PageHeading from "@/Components/PageHeading.vue";
import TabLayout from "@/Layouts/TabLayout.vue";
import { mapStores } from "pinia";
import { useUsersStore } from "@/stores/users.js";
import Container from "@/Components/Container.vue";
import Alert from "@/Components/Alert.vue";


export default {
	name: "UserView",
	components: {Alert, Container, TabLayout, PageHeading},
	data() {
		return {
			user: undefined,
		}
	},
	watch: {
		'$route.params.user': {
			async handler(newValue, oldValue) {
				if(newValue){
					if(this.$route.params.user === 'NEW'){
						this.user = {};
					} else {
						console.log('here2');
						await this.refreshUser();
					}
				} else {
					this.user = undefined;
				}
			},
			immediate: true,
		}
	},
	computed: {
		...mapStores(useUsersStore),
		tabs() {
			return [
				{
					label: this.$t('pages.admin.users.users.user.user_view.summary'),
					current: this.$route.name === 'admin.users.user',
					to: {name: 'admin.users.user', params: this.$route.params}
				},
				{
					label: this.$t('pages.admin.users.users.user.user_view.roles_x', { count: this.user.roles?.length ?? 0}),
          disabled: this.$route.params.user === 'NEW',
					current: this.$route.name === 'admin.users.user.roles',
					to: {name: 'admin.users.user.roles', params: this.$route.params},
					permission: 'read:role-users',
				},
				{
					label: this.$t('pages.admin.users.users.user.user_view.companies_x', { count: this.user.companies?.length ?? 0}),
          disabled: this.$route.params.user === 'NEW',
					current: this.$route.name === 'admin.users.user.companies',
					to: {name: 'admin.users.user.companies', params: this.$route.params},
					permission: 'read:company-users',
				},
			].filter(t => t.permission === undefined || this.$auth.hasPermission(t.permission))
		}
	},
	methods: {
		async refreshUser() {
			try {
				this.user = await this.usersStore.showUser(this.$route.params.user, { include: ['roles','rolesTeams','companies'] });
				if(this.$auth.user?.id === this.user.id){
					this.$auth.fetchUser();
				}
			} catch (e) {
				console.log(e)
			}
		}
	},
}
</script>
